import React from 'react';
import styled from 'styled-components';
//
import Subscribe from 'components/subscribe';
import Content from './content';
import Description from './description';
import { ThumbnailContainer } from './container';
//
export { ThumbnailContainer };
//
const getRatio = (ratio) => {
  switch (ratio) {
    case 'Square':
      return { h: 1, w: 1 };

    default:
      return { h: 9, w: 16 };
  }
};
//
export default ({ fullsize, handleClick, ratio, thumbnail }) => {
  if (!thumbnail) {
    return null;
  }

  const {
    content,
    description,
    descriptionLeft = false,
    height,
    hoverImage,
    image,
    tags,
    videoUrl,
    weblink,
    width,
    listId,
    inputPlaceholder,
  } = thumbnail;

  const h = height || 2;
  const w = description ? width - 1 : width;

  let i = thumbnail?.image?.desktop || thumbnail?.image;
  let hi = thumbnail?.hoverImage?.desktop || thumbnail?.hoverImage;

  if (ratio === 'Square') {
    i = thumbnail?.image?.square || image;
    hi = thumbnail?.hoverImage?.square || hoverImage;
  }

  let classes = `grid-item`;
  if (Array.isArray(tags) && tags.length > 0)
    classes = [classes, ...tags].join(' ');
  const hasMedia = !!i?.url || !!i?.url || !!videoUrl;

  return (
    <Wrap
      columnCount={width}
      rowCount={h}
      className={classes}
      ratios={getRatio(ratio)}
      fullsize={fullsize}
    >
      <Inner>
        {listId && (
          <SubscribeWrap>
            {inputPlaceholder && <p>{inputPlaceholder}</p>}
            <Subscribe listId={listId} />
          </SubscribeWrap>
        )}
        {hasMedia && (
          <Content
            content={content}
            handleClick={handleClick}
            hoverImage={hi}
            image={i}
            mediaWidth={w}
            videoUrl={videoUrl}
            weblink={weblink}
            descriptionLeft={descriptionLeft}
            withDescription={description}
          />
        )}
        {description && (
          <Description
            descriptionLeft={descriptionLeft}
            description={description}
            hasMedia={hasMedia}
            mediaWidth={w}
          />
        )}
      </Inner>
    </Wrap>
  );
};
//
const Wrap = styled.div`
  border: ${({ fullsize }) => (fullsize ? 0 : '0.5vw solid #fff')};
  height: 0;
  margin: 0;
  overflow: ${({ rowCount }) => (rowCount ? 'hidden' : 'auto')};
  padding-top: ${({ fullsize, ratios, rowCount }) =>
    fullsize
      ? `calc(${(ratios.h / ratios.w) * rowCount * 100}%)`
      : `calc(${(ratios.h / ratios.w) * rowCount * 100}% - 1vw)`};
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    padding-top: ${({ fullsize, ratios, rowCount }) =>
      fullsize
        ? `calc(${(ratios.h / ratios.w / 4) * rowCount * 100}%)`
        : `calc(${(ratios.h / ratios.w / 4) * rowCount * 100}% - 1vw)`};
    width: ${({ columnCount }) => `${25 * columnCount}%`};
  }
`;

const Inner = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
`;

const SubscribeWrap = styled.div`
  align-items: center;
  background-color: #acc03d;
  bottom: 0;
  display: flex;
  flex-direction: column;
  font-weight: 600;
  justify-content: center;
  left: 0;
  line-height: 1.2;
  padding: 1rem;
  position: absolute;
  right: 0;
  text-align: center;
  text-transform: uppercase;
  top: 0;
  width: 100%;
`;
